<table class="log compact">
	<thead>
		<tr>
			<th></th>
			<th></th>
			<th></th>
			<th></th>
			<th></th>
			<th colspan="2" style="text-align: center">Late Days</th>
		</tr>
		<tr>
			<th>Organization</th>
			<th>Fleet</th>
			<th>Asset</th>
			<th>OBCU</th>
			<th>Last Login</th>
			<th>Current</th>
			<th>Max</th>
		</tr>
	</thead>
	@for (asset of goneDarkAssets; track asset) {
		<tbody>
			<tr>
				<td>{{asset.organization_name}}</td>
				<td>{{asset.fleet_name}}</td>
				<td><a href="javascript:void(0)" (click)="SelectAsset(asset)">{{asset.asset_name}}</a></td>
				<td>{{asset.obcu_serial_number}}</td>
				<td [style.color]="asset.late_days | gonedarkcolor : asset.gonedark_days">{{asset.last_login | datetime : "localshort"}}</td>
				<td [style.color]="asset.late_days | gonedarkcolor : asset.gonedark_days">{{asset.late_days}}</td>
				<td [style.color]="asset.late_days | gonedarkcolor : asset.gonedark_days">{{asset.gonedark_days}}</td>
			</tr>
		</tbody>
	}
</table>